import DirectDebitPadForm from './direct-debit-pad-form';

export default DirectDebitPadForm;
